import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const boxApi = createApi({
  reducerPath: 'boxApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/order/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["box"],
  endpoints: (builder) => ({
    getBox: builder.query({
      query: ({ guid = '', boxId = "", status }) => {
        return {
          url: "box",
          params: {
            guid: guid,
            tCode: boxId,
            status: status
          }
        }
      },
      providesTags: ["box"],
    }),
    getBoxesByPartial: builder.query({
      query: (guid) => {
        return {
          url: "partial-box",
          params: {
            guid: guid
          }
        }
      },
      providesTags: ["box"],
    }),
    createOrUpdateBox: builder.mutation({
      query: (formData) => {
        return {
          url: `box`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["box"],
    }),
    setOrderToBox: builder.mutation({
      query: (body) => {
        return {
          url: "box-order",
          method: "POST",
          body: body
        }
      },
      invalidatesTags: ["box"],
    }),
    delOrderToBox: builder.mutation({
      query: (body) => {
        return {
          url: "box-order",
          method: "delete",
          body: body
        }
      },
      invalidatesTags: ["box"],
    })
  }),
})

export const { useGetBoxQuery, useCreateOrUpdateBoxMutation, useSetOrderToBoxMutation, useGetBoxesByPartialQuery, useDelOrderToBoxMutation } = boxApi